import "core-js/modules/es.array.concat.js";
import { z } from 'zod';
export var validEligibilityResult = ['eligible', 'ineligible', 'ineligible_with_issues', 'eligible_with_issues', 'application_already_exists', 'profile_incomplete'];
var validEligibilityResultSchema = z.union([z.literal('eligible'), z.literal('ineligible'), z.literal('ineligible_with_issues'), z.literal('eligible_with_issues'), z.literal('application_already_exists'), z.literal('profile_incomplete')]);
export var eligibilitySteps = [].concat(validEligibilityResult, ['checking_eligibility', 'eligibility_unknown_error', 'eligibility_network_error']);
var EligibilitySchema = z.union([z.literal('ineligible'), z.literal('eligible')]);
var EngTestEligibilitySchema = z.union([z.literal('eligible'), z.literal('ineligible'), z.literal('conditional'), z.literal('unknown')]);
export var EligibilityDetailsAttributesSchema = z.object({
  eligibility: validEligibilityResultSchema,
  preexistingApplicationId: z.string().optional(),
  intakeAvailable: z["boolean"]().optional(),
  recruitmentRestricted: z["boolean"]().optional(),
  criteria: z.object({
    educationLevel: z.object({
      eligibility: EligibilitySchema
    }).optional(),
    engTest: z.object({
      type: z.string().optional(),
      eligibility: EngTestEligibilitySchema,
      applicantHas: z.string().optional()
    }).optional(),
    gpa: z.object({
      eligibility: EligibilitySchema
    }).optional(),
    gre: z.object({
      eligibility: EligibilitySchema
    }).optional(),
    gmat: z.object({
      eligibility: EligibilitySchema
    }).optional()
  }).optional()
});
export var EligibilityPermissionsAttributesSchema = z.object({
  canApplyIgnoringEligibility: z["boolean"]()
});